"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.bulkUpload.files.successProcessing': 'Twoje {count} plik(i) będą przetwarzane w tle i dodane do bazy wiedzy.',
    'knowledge.bulkUpload.files.partialSuccess': '{successCount} plik(i) będą przetwarzane w tle, {errorCount} nie powiodło się.',
    'knowledge.bulkUpload.files.allFailed': 'Nie udało się przesłać wszystkich {count} plików.',
    'knowledge.bulkUpload.googleDrive.successProcessing': 'Katalog Google Drive "{directoryName}" będzie przetwarzany w tle i dodany do bazy wiedzy.',
};
